export const requestNews = () => async (dispatch, getState, { api }) => {
    try {
        const response = await api.get_all_news();
        dispatch({
            type: 'NEWS__RECEIVED__OK',
            news: response.news_list,
        });
    }
    catch (error) {
        dispatch({
            type: 'NEWS__RECEIVED__FAIL',
            message: error?.json?.error_ui ?? 'Не удалось получить ответ',
        });
    }
};
export const updateDateLastNewsRead = () => async (dispatch, getState, { api }) => {
    try {
        dispatch({ type: 'DATE_LAST_READ_NEWS__UPDATE__REQUEST' });
        await api.update_date_last_reading();
    }
    catch (error) { }
};
export function create_reducer(PRELOAD) {
    return (state = { news_list: PRELOAD.news ?? [] }, action) => {
        switch (action.type) {
            case 'NEWS__RECEIVED__OK':
                return { ...state, news_list: action.news };
            case 'NEWS__RECEIVED__FAIL':
                return { ...state, news_list: [] };
            default:
                return state;
        }
    };
}
